import generateHandleActions from 'redux/state-handler';
import {
  LIST_PRESENCES,
  SEND_MESSAGE,
  MESSAGE_READ,
} from 'redux/constants';

const apiStates = [
  { type: LIST_PRESENCES, name: 'presences' },
  { type: SEND_MESSAGE, name: 'message' },
  { type: MESSAGE_READ, name: 'message' },
];
const instantStates = [];
const storage = {};
const listValues = ['presences'];

export default generateHandleActions({
  apiStates, instantStates, storage, listValues,
});
